export const environment = {
  production: false,
  baseUrl: "https://apim-dev-cus-01.azure-api.net/",
  powerBiUrl: "https://logic-services-dev-cus-02.appenv-alb-dev-cus-01.p.azurewebsites.net:443/api/wf-services-http-get-powerbitokens/triggers/When_an_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_an_HTTP_request_is_received%2Frun&sv=1.0&sig=vUMU7ndk-NHx9-Kujp0KoVb9T0TEB14ZdMekDBXZdcA",
  redirectUrl: "http://localhost:63036",
  ocpApimSubscriptionKey: "ba227dc1bfc64d588bef524e980b5249",
  version: "v0.6.0",
};
